"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    getMeasurement = _useStylesUtils.getMeasurement;
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    _props$zIndex = props.zIndex,
    zIndex = _props$zIndex === void 0 ? 9999 : _props$zIndex,
    type = props.type,
    _props$width = props.width,
    width = _props$width === void 0 ? '666' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 'auto' : _props$height;
  var ccModalStyle = (0, _react.useMemo)(function () {
    var containerMobileProps = function containerMobileProps() {
      if (isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    var blockerLayoutMobileProps = function blockerLayoutMobileProps() {
      if (layout === 'popup') {
        return {
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: zIndex,
          transition: 'opacity 0.6s ease',
          opacity: isOpen ? 1 : 0
        };
      }
      return {};
    };
    var layoutTypeMobileProps = function layoutTypeMobileProps() {
      if (layout === 'popup') {
        var popupProps;
        if (isMobileView) {
          popupProps = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%'
          };
        } else {
          popupProps = {
            top: pxToRem(31),
            left: '50%',
            transform: 'translateX(-50%)',
            width: getMeasurement(width),
            height: getMeasurement(height),
            maxWidth: "calc(100% - ".concat(pxToRem(45), ")"),
            maxHeight: "calc(100% - ".concat(pxToRem(62), ")"),
            borderRadius: pxToRem(10)
          };
        }
        var outline = 'none';
        if (!isMobileView) {
          switch (type) {
            case 'alert':
              outline = "".concat(pxToRem(2), " solid ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.alert, ";");
              break;
            case 'success':
              outline = "".concat(pxToRem(2), " solid ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.success, ";");
              break;
            default:
              outline = 'none';
              break;
          }
        }
        return _objectSpread({
          position: 'fixed',
          display: 'flex',
          flexFlow: 'column',
          backgroundColor: '#fff',
          outline: outline,
          zIndex: zIndex
        }, popupProps);
      } else {
        if (isMobileView) {
          return {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          };
        }
        return {};
      }
    };
    var closeBtnDirectionMobileProps = function closeBtnDirectionMobileProps() {
      var left;
      var right;
      var top = isMobileView ? pxToRem(12) : pxToRem(-18);
      if (direction === 'rtl') {
        left = isMobileView ? pxToRem(14) : pxToRem(-18);
        right = 'auto';
      } else {
        right = isMobileView ? pxToRem(14) : pxToRem(-18);
        left = 'auto';
      }
      return {
        top: top,
        left: left,
        right: right
      };
    };
    var ccModalContainer = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily,
      fontSize: basicFontSize
    }, containerMobileProps()));
    var ccModalBlocker = (0, _css.css)(_objectSpread({}, blockerLayoutMobileProps()));
    var ccModal = (0, _css.css)(_objectSpread({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      border: 0,
      padding: 0,
      margin: 0,
      insetInlineStart: 'auto',
      insetInlineEnd: 'auto'
    }, layoutTypeMobileProps()));
    var ccModalCloseBtn = (0, _css.css)(_objectSpread({
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: zIndex
    }, closeBtnDirectionMobileProps()));
    return {
      ccModalContainer: ccModalContainer,
      ccModalBlocker: ccModalBlocker,
      ccModal: ccModal,
      ccModalCloseBtn: ccModalCloseBtn
    };
  }, [basicFontSize, direction, fontFamily, getMeasurement, height, isMobileView, isOpen, layout, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.alert, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.success, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, type, width, zIndex]);
  return {
    'cc-Modal-container': ccModalStyle.ccModalContainer,
    'cc-Modal-blocker': ccModalStyle.ccModalBlocker,
    'cc-Modal': ccModalStyle.ccModal,
    'cc-Modal__close-btn': ccModalStyle.ccModalCloseBtn
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;